export const indexCopy = {
  index_headline: "<bold>Typowany JavaScript w każdej skali.</bold>",
  index_byline: "TypeScript rozszerza JavaScript poprzez dodatek typów.",
  index_summary:
    "TypeScript rozumie JavaScript, przez co oszczędzaj Twój czas wyłapując błędy i dostarczając rozwiązania problemów zanim uruchomisz kod.",
  index_locations:
    "W każdej przeglądarce internetowej i systemie operacyjnym, gdziekolwiek działa JavaScript. Całkowicie Open Source.",

  index_cta_play: "Wypróbuj w swojej przeglądarce internetowej",
  index_cta_install: "Zainstaluj lokalnie",

  index_what_is: "Czym jest TypeScript?",

  index_what_is_js: "JavaScript i więcej",
  index_what_is_js_copy: `
<p>TypeScript jest językiem z otwartym kodem źródłowym, opartym na JavaScript -- jednym z najpopularniejszych narzędzi na świecie -- poprzez dodatek statycznego typowania.</p>

<p>Typy dostarczają możliwość zdefiniowania kształtu obiektu, zapewniają lepszą dokumentację i pozwalają na użytek TypeScript w celu zapewnienia poprawnego działania kodu.</p>

<p>Używanie typów jest w TypeScript opcjonalne, ponieważ inferencja typów dostarcza wiele możliwości bez konieczności pisania dodatkowych linii kodu.</p>`,

  index_trust: "Wynik, któremu możesz zaufać",
  index_trust_copy_a: `Każdy poprawny kod napisany w JavaScript jest także poprawny w TypeScript. Po drodze możesz otrzymać błędy typowania, ale nie będzie Cię to blokować przed uruchomieniem wyjściowego kodu w JavaScript. Choć zawsze możesz wybrać bardziej restrykcyjne typowanie, nadal masz nad wszystkim kontrolę.`,
  index_trust_copy_b: `Kod napisany w TypeScript jest przekształcony w kod JavaScript za pomocą kompilatora TypeScript lub <babel>Babel</babel>. Ten kod JavaScript jest czystym, prostym kodem, który może być uruchomiony wszędzie tam, gdzie działa JavaScript: w przeglądarce internetowej, w Node.JS lub w Twoich aplikacjach.`,
  index_standards: "Ewolucja wraz ze standardami",
  index_standards_copy: `
  <p>Zespół TypeScript wnosi swój wkład do komisji TC39, które mają na zadaniu pracę nad rozwojem języka JavaScript.</p>

  <p>Każde nowe funkcje, które docierają do poziomu 3, są gotowe do wdrożenia do TypeScript.</p>
  
  <p>Na przykład, zespół TypeScript głosował za propozycjami takimi, jak: opcjonalne tworzenie łańcuchów (optional chaining), lepsza definicja wartości domyślnych (nullish coalescing operator) oraz indeksy dopasowań dla wyrażeń regularnych (RegExp match indices).</p>`,

  index_gradual: "Stopniowa adaptacja",
  index_gradual_copy: `
<p>Przejście na TypeScript nie jest decyzją zerojedynkową. Możesz zacząć stopniowo poprzez dodawanie annotacji JSDoc do istniejącego kodu JavaScript, następnie przez sprawdzenie kilku plików przez TypeScript, a docelowo przez całkowite przekształcenie kodu.</p>

<p>Inferencja typów w TypeScript oznacza, że nie musisz w ogóle definiować typów w swoim kodzie, jeżeli nie potrzebujesz zwiększonego bezpieczeństwa typów.</p>`,

  index_dts: "Typy na każdym biurku",
  index_dts_copy: `
<p>Większość kodu napisanego w JavaScript nie jest typowana, a inferencja typów ma swoje ograniczenia. Dlatego też zespół TypeScript bierze udział w utrzymaniu <dt>Definitely Typed</dt> - projektu społecznościowego, który ma na zadaniu dostarczenie typów i dokumentacji bezpośrednio w kodzie w istniejącym JavaScript.

<p>Projekt ten pozwala społeczności na korzystanie z definicji typów w bibliotekach JavaScript bez wywierania zbędnej presji na ich twórcach.</p>`,

  index_tools: "Konsekwentnie dobre narzędzia",
  index_tools_copy: `
  <p>TypeScript bierze na siebie integrację z wieloma edytorami w celu zapewnienia spójności pracy w każdym środowisku.</p>

  <p>To pozwala na łatwe przejście pomiędzy edytorami takimi, jak <vs>Visual Studio</vs>, <vsc>Visual Studio Code</vsc>, <nova>Nova</nova>, <atom>Atom</atom>, <subl>Sublime Text</subl>, <emacs>Emacs</emacs>, <vim>Vim</vim>, <webs>WebStorm</webs> i <eclipse>Eclipse</eclipse>.</p>

  <p>Integracja edytorów w TypeScript wspiera też JavaScript, tak więc bardzo możliwe, że Twój edytor korzysta już z funkcjonalności TypeScript bez Twojego bezpośredniego zaangażowania.`,

  index_started_title: "Początek",
  index_started_handbook: "Poradnik",
  index_started_handbook_blurb: "Naucz się języka",
  index_started_docs: "Zacznij projekt",
  index_started_docs_blurb: "Znajdź swoje narzędzia",
  index_started_tooling: "Narzędzia",
  index_started_tooling_blurb: "Głęboka analiza TypeScript",
  index_started_community: "Społeczność",
  index_started_community_blurb: "Bądź na bieżąco",
  index_install: "Zainstaluj TypeScript",
  index_install_ref: `
  <p>Zainstaluj TypeScript poprzez komendę npm<install>
  <p>Następnie uruchom kompilator poprzez <code>tsc</code><pre>npx tsc</pre>
  <p>Przeczytaj więcej na temat tego, jak dodać TypeScript do istniejących aplikacji na <download>stronie instalacji</download>
  `,
  index_releases: "Wersje kwartalne",
  index_releases_pt1: "Następną wersją jest ",
  index_releases_pt2: ", która jest planowana na ",
  index_releases_released: "opublikowana",
  index_releases_beta: "Beta",
  index_releases_rc: "RC",

  index_migration_title: "Opowieści o migracjach",
  index_migration_oss: "Otwarte oprogramowanie z TypeScript",
  index_videos_title: "TypeScript w akcji",
}
